import React from 'react';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import homeHeroAi1 from '../assets/images/home-hero-ai-1.jpg';
import homeHeroAi2 from '../assets/images/home-hero-ai-2.jpg';

function Home() {
  return (
    <div>
      <SEO 
        title="Home - AI-Powered Digital Transformation Solutions"
        description="Vithminds delivers AI-first digital transformation for Fortune 500 enterprises. Expert consulting in Agentic AI, intelligent automation, and data-driven insights."
        keywords="AI solutions, digital transformation, Agentic AI, intelligent automation, Fortune 500 consulting, enterprise AI, low-code no-code"
      />
      <StructuredData type="Organization" />
      <StructuredData type="Service" />
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>AI-Powered Digital Transformation</h1>
          <p>
            Vithminds is built by industry leaders with decades of IT expertise, 
            driving measurable value for global enterprises through AI, intelligent automation, 
            and data-driven insights.
          </p>
          <a href="#explore-ai" className="cta-button">Explore Our Solutions</a>
        </div>
      </section>

      {/* Explore AI Section */}
      <section className="section" id="explore-ai">
        <h2 className="section-title">Explore AI Solutions</h2>
        <p className="section-subtitle">
          Transform your business with cutting-edge AI technologies and expert consulting services
        </p>
        <div className="grid-3">
          <div className="card">
            <div className="card-icon">🤖</div>
            <h3 className="card-title">Agentic AI</h3>
            <p className="card-text">
              Implement autonomous AI agents that can make decisions, take actions, 
              and orchestrate complex workflows across your enterprise.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">⚡</div>
            <h3 className="card-title">Intelligent Automation</h3>
            <p className="card-text">
              Automate repetitive tasks and workflows with AI-powered solutions 
              that learn and adapt to your business processes.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">📊</div>
            <h3 className="card-title">Data-Driven Insights</h3>
            <p className="card-text">
              Unlock the power of your data with advanced analytics and AI-driven 
              insights for smarter decision-making.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">🔧</div>
            <h3 className="card-title">Low-Code/No-Code</h3>
            <p className="card-text">
              Accelerate application development with modern low-code platforms 
              that empower your team to build faster.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">🌐</div>
            <h3 className="card-title">Digital Ecosystem</h3>
            <p className="card-text">
              Build interconnected digital ecosystems that enable seamless 
              integration and collaboration across your organization.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">🚀</div>
            <h3 className="card-title">Enterprise Transformation</h3>
            <p className="card-text">
              Lead large-scale digital transformation initiatives with proven 
              strategies and deep CXO-level expertise.
            </p>
          </div>
        </div>
      </section>

      {/* AI Technology Showcase */}
      <section className="section gradient-overlay" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>
        <h2 className="section-title">Powered by Advanced AI Technology</h2>
        <p className="section-subtitle">
          Leveraging cutting-edge AI and machine learning capabilities
        </p>
        <div className="grid-2" style={{ marginTop: '3rem' }}>
          <div className="image-card">
            <img 
              src={homeHeroAi1} 
              alt="AI Technology" 
            />
            <div className="image-card-content">
              <h3 className="card-title">Neural Network Intelligence</h3>
              <p className="card-text">
                State-of-the-art neural networks that process complex data patterns 
                and deliver actionable insights at enterprise scale.
              </p>
            </div>
          </div>
          <div className="image-card">
            <img 
              src={homeHeroAi2} 
              alt="AI Automation" 
            />
            <div className="image-card-content">
              <h3 className="card-title">Intelligent Automation</h3>
              <p className="card-text">
                Advanced automation systems that learn, adapt, and optimize 
                your business processes in real-time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Vithminds */}
      <section className="section section-dark">
        <h2 className="section-title">Why Choose Vithminds</h2>
        <p className="section-subtitle">
          Trusted by enterprises worldwide for our expertise and track record
        </p>
        <div className="grid-2">
          <div className="card glass-card">
            <div className="card-icon float-animation">👥</div>
            <h3 className="card-title" style={{ color: 'white' }}>Industry Leaders</h3>
            <p className="card-text" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              Our team comprises industry leaders with decades of IT expertise 
              and proven track records in Fortune 500 enterprises.
            </p>
          </div>
          <div className="card glass-card">
            <div className="card-icon float-animation" style={{ animationDelay: '0.5s' }}>🎯</div>
            <h3 className="card-title" style={{ color: 'white' }}>AI-First Strategy</h3>
            <p className="card-text" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              We specialize in AI-first strategies that modernize legacy systems 
              and unlock new sources of growth.
            </p>
          </div>
          <div className="card glass-card">
            <div className="card-icon float-animation" style={{ animationDelay: '1s' }}>🤝</div>
            <h3 className="card-title" style={{ color: 'white' }}>Partner Ecosystem</h3>
            <p className="card-text" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              Backed by trusted advisors and a powerful partner ecosystem 
              to accelerate transformation at scale.
            </p>
          </div>
          <div className="card glass-card">
            <div className="card-icon float-animation" style={{ animationDelay: '1.5s' }}>📈</div>
            <h3 className="card-title" style={{ color: 'white' }}>Measurable Results</h3>
            <p className="card-text" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              Proven track record in delivering measurable value through 
              large-scale transformation programs.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div style={{ textAlign: 'center' }}>
          <h2 className="section-title">Ready to Transform Your Business?</h2>
          <p className="section-subtitle">
            Let's discuss how Vithminds can help accelerate your digital transformation journey
          </p>
          <a href="/contact-us" className="cta-button">Get in Touch</a>
        </div>
      </section>
    </div>
  );
}

export default Home;